import { Post } from "../../type/post.type";

export const getAllPost = (posts: any) => {
  const filteredPost = posts?.map((post: Post) => ({
    _id: post._id,
    author: post.author,
    location: post.location,
    content: post.content,
    media: post.media,
    comment: post.comment,
    likes: post.likes,
    share: post.share,
    views: post.views,
    createdAt: post.createdAt,
  }));

  const cleanCode = filteredPost?.filter((post: Post) => {
    return post._id && post.author && post.content;
  });
  return cleanCode;
};
